export const config = {
  baseUrl: '/api',
  placeholderImage: '/images/placeholder-512x512.png'
};

export default config;

